import { toast } from 'react-toastify';
import OAuthCredentialForm from '@/components/OAuthCredentialForm/OAuthCredentialForm';
import { useGetWellsFargoApiCredential } from '@/api/hooks/wells-fargo-settings/useGetWellsFargoApiCredential';
import { useSaveWellsFargoApiCredential } from '@/api/hooks/wells-fargo-settings/useSaveWellsFargoApiCredential';
import { useTestWellsFargoApiCredential } from '@/api/hooks/wells-fargo-settings/useTestWellsFargoApiCredential';

const SETTINGS_FIELDS = [
  { name: 'gateway_entity_id', label: 'Gateway Entity ID' },
];
const WELLS_FARGO_SCOPES = ['INSTPYMT-Read', 'INSTPYMT-Write', 'WBHK-Webhooks'];
const READ_ONLY_MESSAGE =
  "This Organization is assigned to a Managed Account, so the Managed Account's Wells Fargo API credential applies. These credentials are read-only.";

const WellsFargoApiCredentialSection = ({ organizationId }) => {
  const {
    data,
    loading,
    error: loadError,
    refetch,
  } = useGetWellsFargoApiCredential(organizationId);
  const { saveCredential, loading: saving } = useSaveWellsFargoApiCredential();
  const {
    testing,
    testResult,
    testCredential,
    clearTestResult,
  } = useTestWellsFargoApiCredential(organizationId);

  const handleSave = async (payload) => {
    clearTestResult();
    const response = await saveCredential(organizationId, payload);
    toast.success('Wells Fargo API credential saved successfully');
    return response.data;
  };

  const handleTest = async () => {
    try {
      await testCredential();
    } catch (error) {
      console.error('Failed to test Wells Fargo API credential', error);
    }
  };

  return (
    <OAuthCredentialForm
      title='Wells Fargo API Credentials'
      providerName='Wells Fargo'
      readOnlyMessage={READ_ONLY_MESSAGE}
      data={data}
      loading={loading}
      loadError={loadError}
      onRetry={refetch}
      saving={saving}
      testing={testing}
      testResult={testResult}
      onSave={handleSave}
      onTest={handleTest}
      settingsFields={SETTINGS_FIELDS}
      scopeOptions={WELLS_FARGO_SCOPES}
    />
  );
};

export default WellsFargoApiCredentialSection;
